import { CreateSuggestionOrCriticism } from 'domain/usecases/patient/create-suggestion-or-criticism'
import { PatientRepository } from 'repository/interfaces/patient-repository'

export class RemoteAddSuggestionOrCriticism
  implements CreateSuggestionOrCriticism
{
  constructor(private readonly patientRepository: PatientRepository) {}

  add(
    params: CreateSuggestionOrCriticism.Params
  ): Promise<CreateSuggestionOrCriticism.Model> {
    return this.patientRepository.createSuggestionOrCriticism(params)
  }
}
